import React from 'react';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setPlan } from '../../../store/reducers/subscriptionSlice/subscriptionSlice';

const PricingCard = ({ plan, billing }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const handleSelectPlan = () => {
		if (plan.custom) {
			navigate('/contact-sales');
			return;
		}

		dispatch(
			setPlan({
				id: plan.id || plan.title,
				title: plan.title,
				monthlyPrice: plan.monthlyPrice,
				yearlyPrice: plan.yearlyPrice,
				billing,
			}),
		);

		navigate('/checkout');
	};

	return (
		<div className="pricing-card">
			<h5 className="title">{plan.title}</h5>
			<p className="desc">{plan.description}</p>

			{/* Price */}
			<div className="price">
				{plan.custom ? (
					<span className="contact">Contact Us</span>
				) : billing === 'yearly' && plan.showYearlyDiscount ? (
					<div className="yearly-price">
						<div className="price-row">
							<p className="old-price">
								₹{plan.monthlyPrice}/<span>Month</span>
							</p>
							<span className="new-price">
								₹{plan.yearlyPrice}
								<span className="duration">/Year</span>
							</span>
						</div>

						<div className="save-text">
							Save ₹{plan.monthlyPrice * 12 - plan.yearlyPrice} annually
						</div>
					</div>
				) : (
					<>
						₹
						<span className="amount">
							{billing === 'monthly' ? plan.monthlyPrice : plan.yearlyPrice}
						</span>
						<span className="duration">/{billing === 'monthly' ? 'Month' : 'Year'}</span>
					</>
				)}
			</div>

			{/* Features */}
			<ul className="features">
				{plan.features.map((item, i) => (
					<li key={i}>
						<IoMdCheckmarkCircleOutline className="icon" />
						<span>{item}</span>
					</li>
				))}
			</ul>

			{/* CTA BUTTONS */}
			<div className="btn-group-custom">
				<button
					onClick={handleSelectPlan}
					className="btn btn-primary w-100"
				>
					{plan.cta}
				</button>
				{!plan.custom && <button className="btn btn-primary w-100">Learn More</button>}
			</div>
		</div>
	);
};

export default PricingCard;
